/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Section_PackagingInputs */

const vi_confirm_return_section_packaging = /** @type {(inputs: Confirm_Return_Section_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì đã trừ`)
};

/**

* @param {Confirm_Return_Section_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_section_packaging = /** @type {((inputs?: Confirm_Return_Section_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Section_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_section_packaging(inputs)
});